import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { Repeat } from "lucide-react";

interface Recent {
  parking_spot_id: string;
  address: string;
  price_per_hour: number;
}

const BookAgainCarousel = () => {
  const [items, setItems] = useState<Recent[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetch = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) return;
      const { data } = await supabase
        .from("bookings")
        .select("parking_spot_id, parking_spot:parking_spots(address, price_per_hour)")
        .eq("user_id", session.user.id)
        .in("status", ["confirmed", "completed"])
        .order("created_at", { ascending: false })
        .limit(10);
      const seen = new Set<string>();
      const unique: Recent[] = [];
      (data ?? []).forEach((b: any) => {
        if (b.parking_spot_id && !seen.has(b.parking_spot_id) && b.parking_spot) {
          seen.add(b.parking_spot_id);
          unique.push({
            parking_spot_id: b.parking_spot_id,
            address: b.parking_spot.address,
            price_per_hour: b.parking_spot.price_per_hour,
          });
        }
      });
      setItems(unique.slice(0, 3));
    };
    fetch();
  }, []);

  if (!items.length) return null;

  return (
    <section className="container mx-auto px-4 py-8">
      <h2 className="text-xl font-semibold mb-4 flex items-center"><Repeat className="h-5 w-5 mr-2" /> Book Again</h2>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map((it) => (
          <Card key={it.parking_spot_id} className="hover:shadow-md transition-shadow">
            <CardContent className="p-4">
              <p className="font-medium line-clamp-2">{it.address}</p>
              <p className="text-sm text-muted-foreground mt-1">₹{it.price_per_hour}/hour</p>
              <Button className="w-full mt-3" onClick={() => navigate(`/search?spot=${it.parking_spot_id}`)}>
                Book again
              </Button>
            </CardContent>
          </Card>
        ))}
      </div>
    </section>
  );
};

export default BookAgainCarousel;
